<template>
  <div :class="['content', programStyle]" v-if="form">
    <div class="appeal-container">
      <div class="appeal-details">
        <span class="section-title">{{ selectedForm.layout }} Review Tracking</span>
        <span class="section-label">Request Details:</span>
        <div class="request-details flex-column">
          <ul>
            <li><span>Dealer:</span> {{ selectedForm.dealerName }}</li>
            <li v-if="selectedForm.entity"><span>Dealer Code:</span> {{ selectedForm.entity }}</li>
            <li><span>BC:</span> {{ selectedForm.bc }}</li>
            <li><span>Sales District:</span> {{ selectedForm.salesDistrict }}</li>
            <li><span>Service District:</span> {{ selectedForm.serviceDistrict }}</li>
          </ul>
        </div>
        <span class="section-title">Review Status</span>
      </div>
      <DataTable :headings="fieldReviewTH" :rows="stepRows" :perPage="rowCount" :page="currentPage"> </DataTable>
    </div>
    <div class="form-container" v-if="appeals">
      <div class="item-container" v-for="appeal in appeals" :key="appeal.dialId">
        <div class="left-container flex-column">
          <div :class="['circle', appeal.dialColor]">
            <div class="inner" v-if="appeal.dialResultText">
              {{ appeal.dialResultText }}
            </div>
          </div>
        </div>
        <div class="right-container flex-column">
          <div
            v-if="
              selectedForm.layout === 'Level 2 Charging Equipment' || selectedForm.layout === 'DCFC Charging Equipment'
            "
            class="title-small"
          >
            * PROOF OF CHARGING EQUIPMENT INSTALLATION AND ACTIVATION
          </div>
          <div v-if="selectedForm.layout === 'Final Installation Date of All Charging Equipment'" class="title-small">
            * PROOF OF FINAL INSTALLATION DATE
          </div>
          <div v-if="selectedForm.layout === 'Charging Management Software'" class="title-small">
            * PROOF OF ACTIVE CHARGING MANAGEMENT SOFTWARE
          </div>
          <div class="subtitle">{{ appeal.dialTitle }}</div>
          <div>{{ $t('supporting-documents-0') }}</div>
          <div v-if="appeal.uploads">
            <div class="support-docs" v-for="upload in appeal.uploads" :key="upload.key">
              <span v-if="upload.label === appeal.dialTitle">{{ upload.originalFilename }}</span>
              <a v-if="upload.label === appeal.dialTitle" class="relative" target="_blank" :href="upload.url">
                <img class="download-icon" src="@/assets/img/download-arrow.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          selectedForm.layout === 'Charging Management Software' ||
          selectedForm.layout === 'Final Installation Date of All Charging Equipment'
        "
        class="complex-form-container flex-column"
      >
        <div class="form-details flex-column">
          <h4 class="title">Details</h4>
          <div class="row-1 form-input-info flex-row">
            <ul>
              <li class="input-label" v-if="selectedForm.layout === 'Charging Management Software'">
                <label for="custom-input">* INSTALLER/VALIDATOR VENDOR:</label>
              </li>
              <li
                class="input-label"
                v-if="selectedForm.layout === 'Final Installation Date of All Charging Equipment'"
              >
                <label for="custom-input">* INSTALLER/VALIDATOR VENDOR(S):</label>
              </li>
              <li class="custom-input xl flex-row">
                <input
                  :class="[viewForm ? 'disabled' : '']"
                  required
                  v-model="formDetails.vendor"
                  :placeholder="'Enter name'"
                />
              </li>
              <li
                class="vendor-note"
                v-if="selectedForm.layout === 'Final Installation Date of All Charging Equipment'"
              >
                If you are using multiple installers/validators, please list them all.
              </li>
            </ul>
            <ul v-if="selectedForm.layout === 'Charging Management Software'">
              <li class="input-label"><label for="custom-input">* CHARGING MANAGEMENT SOFTWARE PROVIDER:</label></li>
              <li class="custom-input xl flex-row">
                <input
                  :class="[viewForm ? 'disabled' : '']"
                  required
                  v-model="formDetails.cpms"
                  :placeholder="'Enter name'"
                />
              </li>
            </ul>
            <ul v-else>
              <li class="input-label"><label for="custom-input">* FINAL INSTALLATION DATE:</label></li>
              <li class="custom-input flex-row" :class="[viewForm ? 'disabled' : '']">
                <div class="date">{{ formDetails.date | date }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        v-if="selectedForm.layout === 'Level 2 Charging Equipment' || selectedForm.layout === 'DCFC Charging Equipment'"
        class="complex-form-container flex-column"
      >
        <div class="form-details flex-column">
          <div class="title">Details</div>
          <div class="row-1 flex-row">
            <ul>
              <li class="input-label"><label for="custom-input">* INSTALLER/VALIDATOR VENDOR:</label></li>
              <li class="custom-input xl flex-row" :class="[validationCheck && !formDetails.vendor ? 'required' : '']">
                <input
                  :class="[viewForm ? 'disabled' : '']"
                  required
                  v-model="formDetails.vendor"
                  :placeholder="'Enter name'"
                />
                <span class="custom-input-buttons flex-row" v-if="!viewForm">
                  <span class="edit-button" @click="formDetails.vendor = null">{{ $t('clear') }}</span>
                </span>
              </li>
            </ul>
          </div>
          <div class="row-2" v-if="selectedForm.layout === 'Level 2 Charging Equipment'">
            <div class="row-title-container flex-row">
              <h3 class="collapsible-row-title">L2 CONNECTORS</h3>
            </div>
            <div id="active-l2-chargers">
              <div class="input-fields flex-row">
                <ul>
                  <li class="input-label required-level-two"><label for="custom-input">REQUIRED</label></li>
                  <li class="custom-input md flex-row">
                    <input class="disabled" v-model="formDetails.requiredLevelTwo" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label unidentified-connectors">
                    <label for="custom-input">UNIDENTIFIED CONNECTORS</label>
                  </li>
                  <li
                    class="custom-input md flex-row"
                    :class="[validationCheck && lTwoConnectorsTotal > 0 ? 'required' : '']"
                  >
                    <input class="disabled" v-model="lTwoConnectorsTotal" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label connector-type"><label for="custom-input">COMPLIANT</label></li>
                  <li class="input-label"><label for="custom-input">* INSTALLED/ACTIVE</label></li>
                  <li
                    class="custom-input sm flex-row"
                    :class="[
                      validationCheck && (compliantInstalled === 0 || lTwoConnectorsTotal > 0) ? 'required' : '',
                    ]"
                  >
                    <input class="disabled" v-model="formDetails.lTwoCompliant" />
                  </li>
                  <li class="input-label"><label for="custom-input">* ON ORDER</label></li>
                  <li
                    class="custom-input sm flex-row"
                    :class="[validationCheck && (compliantOnOrder === 0 || lTwoConnectorsTotal > 0) ? 'required' : '']"
                  >
                    <input class="disabled" v-model="formDetails.lTwoOnOrderCompliant" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label connector-type"><label for="custom-input">NON-COMPLIANT</label></li>
                  <li class="input-label"><label for="custom-input">INSTALLED/ACTIVE</label></li>
                  <li class="custom-input sm flex-row">
                    <input class="disabled" v-model="formDetails.lTwoNonCompliant" />
                  </li>
                  <li class="input-label"><label for="custom-input">ON ORDER</label></li>
                  <li class="custom-input sm flex-row">
                    <input class="disabled" v-model="formDetails.lTwoOnOrderNonCompliant" />
                  </li>
                </ul>
              </div>
              <div class="requirements flex-column">
                <span>L2 Compliant Connector Requirements: >9.6kw CDJR; >11.5kw Alfa.</span>
                <span class="helper-text_error" v-if="validationCheck && lTwoConnectorsTotal > 0"
                  >Your Installed/Active Compliant and On order/Not yet installed Compliant connectors are less than
                  your Required input. If this is correct, you may submit this form again and select “Continue”.</span
                >
              </div>
              <h4 class="equipment-type">INSTALLED/ACTIVE CONNECTORS</h4>
              <div class="standard-charger">
                <h4 class="charger-title">Compliant Connectors</h4>
                <div
                  class="input-fields flex-row"
                  v-for="(charger, index) in formDetails.lTwoInstalledMeta"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">BRAND</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.lTwoInstalledMeta[index].brand"
                        :options="formDetails.lTwoInstalledMeta[index].dropdownOptions.brand"
                        class="multiselect single"
                        :placeholder="'Select a brand'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="viewForm"
                        @input="getComplexFormDropdownOptions('installed', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">MODEL</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.lTwoInstalledMeta[index].model"
                        :options="formDetails.lTwoInstalledMeta[index].dropdownOptions.model"
                        class="multiselect single"
                        :placeholder="'Select a model'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="!formDetails.lTwoInstalledMeta[index].brand || viewForm"
                        @input="resetRowValues('installed-compliant-quantity', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li
                      class="custom-input sm flex-row"
                      :class="[
                        (validationCheck && (compliantInstalled === 0 || lTwoConnectorsTotal > 0) ? 'required' : '') ||
                          (formDetails.lTwoInstalledMeta[index].quantity &&
                          formDetails.lTwoInstalledMeta[index].quantity < 0
                            ? 'required'
                            : ''),
                      ]"
                    >
                      <input
                        :class="[formDetails.lTwoInstalledMeta[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.lTwoInstalledMeta[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.lTwoInstalledMeta, index, 'L2AC', 'Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.lTwoInstalledMeta.length > 1"
                    @click="openModal('remove', formDetails.lTwoInstalledMeta, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
              </div>
              <div class="non-standard-charger">
                <h4 class="charger-title">Non-Compliant Connectors</h4>
                <div
                  class="input-fields non-standard flex-row"
                  v-for="(charger, index) in formDetails.lTwoInstalledOtherFields"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER BRAND</label></li>
                    <li class="custom-input lg flex-row" :class="[viewForm ? 'disabled' : '']">
                      <GInput
                        type="input"
                        v-model="formDetails.lTwoInstalledOtherFields[index].brand"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :disabled="viewForm"
                        @input="resetRowValues('installed-non-compliant-brand', index)"
                      ></GInput>
                      <span class="custom-input-buttons flex-row" v-if="!viewForm">
                        <span
                          class="edit-button"
                          @click="resetRowValues('installed-non-compliant-brand', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER MODEL</label></li>
                    <li
                      class="custom-input lg flex-row"
                      :class="[formDetails.lTwoInstalledOtherFields[index].brand ? '' : 'disabled']"
                      :disabled="viewForm"
                    >
                      <GInput
                        type="input"
                        v-model="formDetails.lTwoInstalledOtherFields[index].model"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :class="[formDetails.lTwoInstalledOtherFields[index].brand ? '' : 'disabled']"
                        :disabled="viewForm"
                        @input="resetRowValues('installed-non-compliant-model', index)"
                      ></GInput>
                      <span
                        v-if="formDetails.lTwoInstalledOtherFields[index].brand"
                        class="custom-input-buttons flex-row"
                        :disabled="viewForm"
                      >
                        <span
                          class="edit-button"
                          @click="resetRowValues('installed-non-compliant-model', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li class="custom-input sm flex-row">
                      <input
                        :class="[formDetails.lTwoInstalledOtherFields[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.lTwoInstalledOtherFields[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.lTwoInstalledOtherFields, index, 'L2AC', 'Non-Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.lTwoInstalledOtherFields.length > 1"
                    @click="openModal('remove', formDetails.lTwoInstalledOtherFields, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
              </div>
              <h4 class="equipment-type">ON ORDER/NOT YET INSTALLED CONNECTORS</h4>
              <div class="standard-charger">
                <h4 class="charger-title">Compliant Connectors</h4>
                <div
                  class="input-fields flex-row"
                  v-for="(charger, index) in formDetails.lTwoUninstalledMeta"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">BRAND</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.lTwoUninstalledMeta[index].brand"
                        :options="formDetails.lTwoUninstalledMeta[index].dropdownOptions.brand"
                        class="multiselect single"
                        :placeholder="'Select a brand'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="viewForm"
                        @input="getComplexFormDropdownOptions('uninstalled', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">MODEL</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.lTwoUninstalledMeta[index].model"
                        :options="formDetails.lTwoUninstalledMeta[index].dropdownOptions.model"
                        class="multiselect single"
                        :placeholder="'Select a model'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="!formDetails.lTwoUninstalledMeta[index].brand || viewForm"
                        @input="resetRowValues('uninstalled-compliant-quantity', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li
                      class="custom-input sm flex-row"
                      :class="[
                        (validationCheck && (compliantOnOrder === 0 || lTwoConnectorsTotal > 0) ? 'required' : '') ||
                          (formDetails.lTwoUninstalledMeta[index].quantity &&
                          formDetails.lTwoUninstalledMeta[index].quantity < 0
                            ? 'required'
                            : ''),
                      ]"
                    >
                      <input
                        :class="[formDetails.lTwoUninstalledMeta[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.lTwoUninstalledMeta[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.lTwoUninstalledMeta, index, 'L2AC', 'Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.lTwoUninstalledMeta.length > 1"
                    @click="openModal('remove', formDetails.lTwoUninstalledMeta, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
              </div>
              <div class="non-standard-charger">
                <h4 class="charger-title">Non-Compliant Connectors</h4>
                <div
                  class="input-fields non-standard flex-row"
                  v-for="(charger, index) in formDetails.lTwoUninstalledOtherFields"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER BRAND</label></li>
                    <li class="custom-input lg flex-row" :class="[viewForm ? 'disabled' : '']">
                      <GInput
                        type="input"
                        v-model="formDetails.lTwoUninstalledOtherFields[index].brand"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :disabled="viewForm"
                        @input="resetRowValues('uninstalled-non-compliant-brand', index)"
                      ></GInput>
                      <span class="custom-input-buttons flex-row" v-if="!viewForm">
                        <span
                          class="edit-button"
                          @click="resetRowValues('uninstalled-non-compliant-brand', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER MODEL</label></li>
                    <li
                      class="custom-input lg flex-row"
                      :class="[formDetails.lTwoUninstalledOtherFields[index].brand ? '' : 'disabled']"
                      :disabled="viewForm"
                    >
                      <GInput
                        type="input"
                        v-model="formDetails.lTwoUninstalledOtherFields[index].model"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :class="[formDetails.lTwoUninstalledOtherFields[index].brand ? '' : 'disabled']"
                        :disabled="viewForm"
                        @input="resetRowValues('uninstalled-non-compliant-model', index)"
                      ></GInput>
                      <span
                        v-if="formDetails.lTwoUninstalledOtherFields[index].brand"
                        class="custom-input-buttons flex-row"
                        :disabled="viewForm"
                      >
                        <span
                          class="edit-button"
                          @click="resetRowValues('uninstalled-non-compliant-model', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li class="custom-input sm flex-row">
                      <input
                        :class="[formDetails.lTwoUninstalledOtherFields[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.lTwoUninstalledOtherFields[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.lTwoUninstalledOtherFields, index, 'L2AC', 'Non-Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.lTwoUninstalledOtherFields.length > 1"
                    @click="openModal('remove', formDetails.lTwoUninstalledOtherFields, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row-3" v-if="selectedForm.layout === 'DCFC Charging Equipment'">
            <div class="row-title-container flex-row">
              <h3 class="collapsible-row-title">DCFC CONNECTORS</h3>
            </div>
            <div id="active-dcfc-charge-equipment">
              <div class="input-fields flex-row">
                <ul>
                  <li class="input-label required-dcfc"><label for="custom-input">REQUIRED</label></li>
                  <li class="custom-input md flex-row">
                    <input class="disabled" v-model="formDetails.requiredDcfcConnectors" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label unidentified-connectors">
                    <label for="custom-input">UNIDENTIFIED CONNECTORS</label>
                  </li>
                  <li
                    class="custom-input md flex-row"
                    :class="[validationCheck && dcfcConnectorsTotal !== 0 ? 'required' : '']"
                  >
                    <input class="disabled" v-model="dcfcConnectorsTotal" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label connector-type"><label for="custom-input">COMPLIANT</label></li>
                  <li class="input-label"><label for="custom-input">* INSTALLED/ACTIVE</label></li>
                  <li
                    class="custom-input sm flex-row"
                    :class="[
                      validationCheck && (compliantInstalled === 0 || dcfcConnectorsTotal > 0) ? 'required' : '',
                    ]"
                  >
                    <input class="disabled" v-model="formDetails.dcfcConnectCompliant" />
                  </li>
                  <li class="input-label"><label for="custom-input">ON ORDER</label></li>
                  <li
                    class="custom-input sm flex-row"
                    :class="[validationCheck && (compliantOnOrder === 0 || dcfcConnectorsTotal > 0) ? 'required' : '']"
                  >
                    <input class="disabled" v-model="formDetails.dcfcOnOrderCompliant" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label connector-type"><label for="custom-input">NON-COMPLIANT</label></li>
                  <li class="input-label"><label for="custom-input">INSTALLED/ACTIVE</label></li>
                  <li class="custom-input sm flex-row">
                    <input class="disabled" v-model="formDetails.dcfcConnectNonCompliant" />
                  </li>
                  <li class="input-label"><label for="custom-input">ON ORDER</label></li>
                  <li class="custom-input sm flex-row">
                    <input class="disabled" v-model="formDetails.dcfcOnOrderNonCompliant" />
                  </li>
                </ul>
              </div>
              <div class="requirements flex-column">
                <span>DCFC Compliant Charger Requirements: >175kw CDJR; >60kw Alfa.</span>
                <span class="helper-text_error" v-if="validationCheck && dcfcConnectorsTotal > 0"
                  >Your Installed/Active Compliant and On order/Not yet installed Compliant connectors are less than
                  your Required input. If this is correct, you may submit this form again and select “Continue”.</span
                >
              </div>
              <h4 class="equipment-type">INSTALLED/ACTIVE CONNECTORS</h4>
              <div class="standard-charger">
                <h4 class="charger-title">Compliant Connectors</h4>
                <div
                  class="input-fields flex-row"
                  v-for="(charger, index) in formDetails.dcfcInstalledMeta"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">BRAND</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.dcfcInstalledMeta[index].brand"
                        :options="formDetails.dcfcInstalledMeta[index].dropdownOptions.brand"
                        class="multiselect single"
                        :placeholder="'Select a brand'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="viewForm"
                        @input="getComplexFormDropdownOptions('installed', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">MODEL</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.dcfcInstalledMeta[index].model"
                        :options="formDetails.dcfcInstalledMeta[index].dropdownOptions.model"
                        class="multiselect single"
                        :placeholder="'Select a model'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="!formDetails.dcfcInstalledMeta[index].brand || viewForm"
                        @input="resetRowValues('installed-compliant-quantity', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li
                      class="custom-input sm flex-row"
                      :class="[
                        (validationCheck && (compliantInstalled === 0 || dcfcConnectorsTotal > 0) ? 'required' : '') ||
                          (formDetails.dcfcInstalledMeta[index].quantity &&
                          formDetails.dcfcInstalledMeta[index].quantity < 0
                            ? 'required'
                            : ''),
                      ]"
                    >
                      <input
                        :class="[formDetails.dcfcInstalledMeta[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.dcfcInstalledMeta[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.dcfcInstalledMeta, index, 'DCFC', 'Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.dcfcInstalledMeta.length > 1"
                    @click="openModal('remove', formDetails.dcfcInstalledMeta, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
              </div>
              <div class="non-standard-charger">
                <h4 class="charger-title">Non-Compliant Connectors</h4>
                <div
                  class="input-fields non-standard flex-row"
                  v-for="(charger, index) in formDetails.dcfcInstalledOtherFields"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER BRAND</label></li>
                    <li class="custom-input lg flex-row" :class="[viewForm ? 'disabled' : '']">
                      <GInput
                        type="input"
                        v-model="formDetails.dcfcInstalledOtherFields[index].brand"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :disabled="viewForm"
                        @input="resetRowValues('installed-non-compliant-brand', index)"
                      ></GInput>
                      <span class="custom-input-buttons flex-row" v-if="!viewForm">
                        <span
                          class="edit-button"
                          @click="resetRowValues('installed-non-compliant-brand', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER MODEL</label></li>
                    <li
                      class="custom-input lg flex-row"
                      :class="[formDetails.dcfcInstalledOtherFields[index].brand ? '' : 'disabled']"
                      :disabled="viewForm"
                    >
                      <GInput
                        type="input"
                        v-model="formDetails.dcfcInstalledOtherFields[index].model"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :class="[formDetails.dcfcInstalledOtherFields[index].brand ? '' : 'disabled']"
                        :disabled="viewForm"
                        @input="resetRowValues('installed-non-compliant-model', index)"
                      ></GInput>
                      <span
                        v-if="formDetails.dcfcInstalledOtherFields[index].brand"
                        class="custom-input-buttons flex-row"
                        :disabled="viewForm"
                      >
                        <span
                          class="edit-button"
                          @click="resetRowValues('installed-non-compliant-model', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li class="custom-input sm flex-row">
                      <input
                        :class="[formDetails.dcfcInstalledOtherFields[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.dcfcInstalledOtherFields[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.dcfcInstalledOtherFields, index, 'DCFC', 'Non-Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column test"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.dcfcInstalledOtherFields.length > 1"
                    @click="openModal('remove', formDetails.dcfcInstalledOtherFields, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
              </div>
              <h4 class="equipment-type">ON ORDER/NOT YET INSTALLED CONNECTORS</h4>
              <div class="standard-charger">
                <h4 class="charger-title">Compliant Connectors</h4>
                <div
                  class="input-fields flex-row"
                  v-for="(charger, index) in formDetails.dcfcUninstalledMeta"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">BRAND</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.dcfcUninstalledMeta[index].brand"
                        :options="formDetails.dcfcUninstalledMeta[index].dropdownOptions.brand"
                        class="multiselect single"
                        :placeholder="'Select a brand'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="viewForm"
                        @input="getComplexFormDropdownOptions('uninstalled', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">MODEL</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.dcfcUninstalledMeta[index].model"
                        :options="formDetails.dcfcUninstalledMeta[index].dropdownOptions.model"
                        class="multiselect single"
                        :placeholder="'Select a model'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="!formDetails.dcfcUninstalledMeta[index].brand || viewForm"
                        @input="resetRowValues('uninstalled-compliant-quantity', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li
                      class="custom-input sm flex-row"
                      :class="[
                        (validationCheck && (compliantOnOrder === 0 || dcfcConnectorsTotal > 0) ? 'required' : '') ||
                          (formDetails.dcfcUninstalledMeta[index].quantity &&
                          formDetails.dcfcUninstalledMeta[index].quantity < 0
                            ? 'required'
                            : ''),
                      ]"
                    >
                      <input
                        :class="[formDetails.dcfcUninstalledMeta[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.dcfcUninstalledMeta[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.dcfcUninstalledMeta, index, 'DCFC', 'Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.dcfcUninstalledMeta.length > 1"
                    @click="openModal('remove', formDetails.dcfcUninstalledMeta, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
              </div>
              <div class="non-standard-charger">
                <h4 class="charger-title">Non-Compliant Connectors</h4>
                <div
                  class="input-fields non-standard flex-row"
                  v-for="(charger, index) in formDetails.dcfcUninstalledOtherFields"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER BRAND</label></li>
                    <li class="custom-input lg flex-row" :class="[viewForm ? 'disabled' : '']">
                      <GInput
                        type="input"
                        v-model="formDetails.dcfcUninstalledOtherFields[index].brand"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :disabled="viewForm"
                        @input="resetRowValues('uninstalled-non-compliant-brand', index)"
                      ></GInput>
                      <span class="custom-input-buttons flex-row" v-if="!viewForm">
                        <span
                          class="edit-button"
                          @click="resetRowValues('uninstalled-non-compliant-brand', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER MODEL</label></li>
                    <li
                      class="custom-input lg flex-row"
                      :class="[formDetails.dcfcUninstalledOtherFields[index].brand ? '' : 'disabled']"
                      :disabled="viewForm"
                    >
                      <GInput
                        type="input"
                        v-model="formDetails.dcfcUninstalledOtherFields[index].model"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :class="[formDetails.dcfcUninstalledOtherFields[index].brand ? '' : 'disabled']"
                        :disabled="viewForm"
                        @input="resetRowValues('uninstalled-non-compliant-model', index)"
                      ></GInput>
                      <span
                        v-if="formDetails.dcfcUninstalledOtherFields[index].brand"
                        class="custom-input-buttons flex-row"
                        :disabled="viewForm"
                      >
                        <span
                          class="edit-button"
                          @click="resetRowValues('uninstalled-non-compliant-model', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li class="custom-input sm flex-row">
                      <input
                        :class="[formDetails.dcfcUninstalledOtherFields[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.dcfcUninstalledOtherFields[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.dcfcUninstalledOtherFields, index, 'DCFC', 'Non-Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column test"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.dcfcUninstalledOtherFields.length > 1"
                    @click="openModal('remove', formDetails.dcfcUninstalledOtherFields, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="signature">
          <div class="title">Uploader</div>
          <div class="input-fields flex-row">
            <ul>
              <li class="input-label">Date:</li>
              <li class="custom-input disabled">
                <span class="date">{{ date | date }}</span>
              </li>
            </ul>
            <ul>
              <li><label for="custom-input">* Name:</label></li>
              <li
                class="custom-input flex-row"
                :class="[validationCheck && !formDetails.dealerSignature ? 'required' : '']"
              >
                <input
                  :class="[viewForm ? 'disabled' : '']"
                  required
                  v-model="formDetails.dealerSignature"
                  :placeholder="'Enter name'"
                />
                <span class="custom-input-buttons flex-row" v-if="!viewForm">
                  <span class="edit-button" @click="formDetails.dealerSignature = null">{{ $t('clear') }}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bottom-container" v-for="status in stepRows" :key="status.stepName">
        <div class="bottom-info bottom-border" v-if="status.id && status.stepName !== 'Dealer'">
          <span class="section-title" v-if="status.stepName === 'HQ'">Previous Level Status</span>
          <span class="section-label">{{ status.stepName }}:</span>
          <span class="section-label">* REVIEW FORM:</span>
          <div class="dial">
            <div class="flex-row radio-container" v-if="status.stepName === 'HQ'">
              <button :class="status.result === 'Approved' ? 'radio-selected' : 'radio'">
                <div v-if="status.result === 'Approved'" class="selected"></div>
              </button>
              <span>Approve</span>
            </div>
            <div class="flex-row radio-container" v-if="status.stepName === 'HQ'">
              <button :class="status.result === 'Declined' ? 'radio-selected' : 'radio'">
                <div v-if="status.result === 'Declined'" class="selected"></div>
              </button>
              <span>{{ $t('deny') }}</span>
            </div>
            <div
              class="flex-row radio-container"
              v-if="status.stepName === 'EVR Audit' && reviewerStatus === 'Declined'"
            >
              <button :class="status.result === 'Approved' ? 'radio-selected' : 'radio'">
                <div v-if="status.result === 'Approved'" class="selected"></div>
              </button>
              <span>Approve</span>
            </div>
            <div
              class="flex-row radio-container"
              v-if="status.stepName === 'EVR Audit' && reviewerStatus === 'Approved'"
            >
              <button :class="status.result === 'Declined' ? 'radio-selected' : 'radio'">
                <div v-if="status.result === 'Declined'" class="selected"></div>
              </button>
              <span>{{ $t('deny') }}</span>
            </div>
            <div
              class="flex-row radio-container"
              v-if="
                selectedForm.config.domain === 'US EVR' &&
                (selectedForm.layout === 'Final Installation Date of All Charging Equipment' ||
                  selectedForm.layout === 'Level 2 Charging Equipment' ||
                  selectedForm.layout === 'DCFC Charging Equipment') &&
                status.stepName === 'EVR Audit'
              "
            >
              <button :class="status.result === 'Expired' ? 'radio-selected' : 'radio'">
                <div v-if="status.result === 'Expired'" class="selected"></div>
              </button>
              <span>Expired</span>
            </div>
          </div>
          <span class="label">Reason:</span>
          <textarea readonly v-model="status.reason" />
          <div class="flex-row input-info">
            <div class="flex-column">
              <span class="label">* Name:</span>
              <input readonly v-model="status.name" />
            </div>
            <div class="flex-column">
              <span class="label">* Title:</span>
              <input readonly v-model="status.title" />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container">
        <div class="bottom-info" v-if="form.permissions[0].canSubmit || form.permissions[0].canOverride">
          <span class="section-title">Current Level Status</span>
          <span class="section-label" v-if="form.permissions[0].canOverride">EVR Audit:</span>
          <span class="section-label" v-if="!form.permissions[0].canOverride">{{ currentLevel }}:</span>
          <span class="section-label">* REVIEW FORM:</span>
          <div class="dial">
            <div
              class="flex-row radio-container"
              v-if="this.reviewerLevelStatus === 'Pending' || this.reviewerLevelStatus === 'Declined'"
            >
              <button :class="result === 'Approved' ? 'radio-selected' : 'radio'" @click="result = 'Approved'">
                <div v-if="result === 'Approved'" class="selected"></div>
              </button>
              <span>{{ $t('approve') }}</span>
            </div>
            <div
              class="flex-row radio-container"
              v-if="this.reviewerLevelStatus === 'Pending' || this.reviewerLevelStatus === 'Approved'"
            >
              <button :class="result === 'Declined' ? 'radio-selected' : 'radio'" @click="result = 'Declined'">
                <div v-if="result === 'Declined'" class="selected"></div>
              </button>
              <span>{{ $t('deny') }}</span>
            </div>
            <div class="flex-row radio-container" v-if="form.permissions[0].canExpire">
              <button :class="result === 'Expired' ? 'radio-selected' : 'radio'" @click="result = 'Expired'">
                <div v-if="result === 'Expired'" class="selected"></div>
              </button>
              <span>{{ $t('expired') }}</span>
            </div>
          </div>
          <span class="label">{{ $t('reason-0') }}:</span>
          <GInput
            type="textarea"
            v-model="reason"
            placeholder="Enter a reason"
            maxlength="1000"
            :showCount="true"
          ></GInput>
          <div class="flex-row input-info">
            <div class="flex-column">
              <span class="label">* {{ $t('name') }}:</span>
              <input readonly v-model="name" />
            </div>
            <div class="flex-column">
              <span class="label">* {{ $t('title') }}:</span>
              <div class="custom-input flex-row title-box">
                <input placeholder="Enter title" v-model="title" />
                <span class="custom-input-buttons flex-row">
                  <span class="edit-button" :class="[title ? '' : 'disabled']" @click="title = null">{{
                    $t('clear')
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <span class="section-label">* Signature:</span>
          <div class="signature-section flex-column">
            <div class="flex-row signature-input">
              <div class="signature-icon"><SignatureIcon /></div>
              <VueSignaturePad id="signature" width="400px" height="100px" ref="signaturePad" :options="options" />
            </div>
            <span class="signature-confirmation" v-if="signature">{{ $t('signature-saved') }}</span>
            <div class="signature-buttons flex-row">
              <span class="custom-input-buttons flex-row">
                <span class="edit-button" @click="saveSignature">{{ $t('save-signature') }}</span
                ><span class="separator">|</span
                ><span class="edit-button" @click="clearSignature">{{ $t('clear') }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="button-container flex-row">
          <button
            v-if="form.permissions[0].canSubmit || form.permissions[0].canOverride"
            value="save"
            @click="save"
            :class="[fullValidationCheck ? '' : 'disabled']"
          >
            {{ $t('submit') }}
          </button>
          <button class="cancel-button" @click="exit">{{ $t('exit') }}</button>
          <div v-if="invalidPermissions">
            {{ $t('contact-admin') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import DataTable from '@/components/DataTable.vue';
import Multiselect from 'vue-multiselect';
import GInput from '@/components/GComponents/GInput.vue';
import { mapState } from 'vuex';
import fieldReviewTH from '@/utils/tableHeaders/fieldReviewTH';
import SignatureIcon from '@/assets/icons/delete-icn.svg';

export default {
  name: 'FieldComplex',
  components: { DataTable, GInput, Multiselect, SignatureIcon },
  props: {
    selectedForm: {
      type: Object,
    },
  },
  data() {
    return {
      value: 'appeals',
      date: new Date(),
      status: null,
      form: null,
      rowCount: 7,
      currentPage: 1,
      stepRows: [],
      formInfo: null,
      appeals: [],
      formId: null,
      result: null,
      reason: null,
      title: null,
      options: {
        penColor: '#000000',
      },
      signature: null,
      invalidPermissions: false,
      fieldReviewTH: fieldReviewTH(),
      reviewerLevelStatus: null,
      formDetails: {
        dealerSignature: null,
        vendor: null,
        cpms: null,
        lTwoCompliant: null,
        lTwoOnOrderCompliant: null,
        lTwoOnOrderNonCompliant: null,
        lTwoNonCompliant: null,
        // dcfcCompliant: null,
        // dcfcNonCompliant: null,
        dcfcConnectCompliant: null,
        dcfcConnectNonCompliant: null,
        dcfcOnOrderCompliant: null,
        dcfcOnOrderNonCompliant: null,
        requiredLevelTwo: null,
        // requiredDcfc: null,
        requiredDcfcConnectors: null,
        lTwoInstalledMeta: [
          {
            brand: null,
            model: null,
            quantity: null,
            dropdownOptions: {
              brand: [],
              model: [],
            },
          },
        ],
        lTwoInstalledOtherFields: [
          {
            brand: null,
            model: null,
            quantity: null,
          },
        ],
        lTwoUninstalledMeta: [
          {
            brand: null,
            model: null,
            quantity: null,
            dropdownOptions: {
              brand: [],
              model: [],
            },
          },
        ],
        lTwoUninstalledOtherFields: [
          {
            brand: null,
            model: null,
            quantity: null,
          },
        ],
        dcfcInstalledMeta: [
          {
            brand: null,
            model: null,
            quantity: null,
            dropdownOptions: {
              brand: [],
              model: [],
            },
          },
        ],
        dcfcInstalledOtherFields: [
          {
            brand: null,
            model: null,
            quantity: null,
          },
        ],
        dcfcUninstalledMeta: [
          {
            brand: null,
            model: null,
            quantity: null,
            dropdownOptions: {
              brand: [],
              model: [],
            },
          },
        ],
        dcfcUninstalledotherFields: [
          {
            brand: null,
            model: null,
            quantity: null,
          },
        ],
      },
      viewForm: true,
      chargingEquipmentFormType: null,
      lTwoConnectorsTotal: null,
      dcfcConnectorsTotal: null,
    };
  },
  methods: {
    save() {
      if (this.fullValidationCheck) {
        const params = {
          formId: this.selectedForm.formId,
          result: this.result,
          fieldSignature: this.signature,
          reason: this.reason,
          title: this.title,
        };
        this.submitFieldForm(params);
      }
    },
    submitFieldForm(params) {
      this.$store
        .dispatch('updateForm', params)
        .then((res) => {
          if (res === 'invalid_permissions') {
            this.invalidPermissions = true;
          } else {
            this.$notify({
              group: 'primary',
              type: 'success',
              text: this.$t('form-successfully-submitted'),
            });
            this.exit();
          }
        })
        .catch(() => {});
    },
    exit() {
      this.$emit('exit');
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.signature = data;
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.signature = null;
    },
    getForm() {
      const loader = this.$loading.show();
      const { formId } = this.selectedForm;

      this.$store
        .dispatch('getForm', { formId })
        .then((res) => {
          if (res) {
            this.form = res;
            this.form.steps.forEach((step) => {
              if (step.status.id) {
                this.$set(step.status, 'stepName', step.stepName);
                this.stepRows.push(step.status);
              } else {
                this.stepRows.push({
                  stepName: step.stepName,
                  result: 'Pending',
                });
              }
            });
            this.form.items.forEach((item) => {
              this.appeals.push(item);
            });
            this.currentLevel = this.stepRows.find((step) => step.stepName !== 'Dealer' && step.result === 'Pending')
              ?.stepName
              ? this.stepRows.find((step) => step.stepName !== 'Dealer' && step.result === 'Pending')?.stepName
              : 'HQ';
            this.reviewerLevelStatus = this.stepRows.find((step) => step.stepName === 'HQ')?.result;
          }
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    getComplexFormSupplementalData() {
      const loader = this.$loading.show();

      const { domain } = this.selectedForm.config;
      const { entity } = this.selectedForm;
      const { formId } = this.selectedForm;

      this.$store
        .dispatch('getComplexFormSupplementalData', { formId, domain, entity })
        .then((res) => {
          Object.assign(this.formDetails, res);
          this.lTwoConnectorsTotal = res.lTwoConnectorsTotal;
          this.dcfcConnectorsTotal = res.dcfcConnectorsTotal;
          this.formDetails.dealerSignature = this.selectedForm.dealerSignature;
          this.setFormType(res);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setFormType(res) {
      if (res.lTwoInstalledMeta.length > 0) {
        this.chargingEquipmentFormType = 'levelTwo';
      } else {
        this.chargingEquipmentFormType = 'DCFC';
      }
    },
  },
  computed: {
    ...mapState('global', ['programStyle']),
    name() {
      const user = JSON.parse(localStorage.getItem('stellantis-user'));
      const fullName = `${user.firstName} ${user.lastName}`;

      return fullName;
    },
    fullValidationCheck() {
      if (this.title && this.reason && this.signature && this.result) {
        return true;
      }
      return false;
    },
    reviewerStatus() {
      return this.stepRows.find((step) => step.stepName === 'HQ')?.result;
    },
  },
  watch: {},
  created() {
    this.getForm();
    this.getComplexFormSupplementalData();
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #000000;
  text-align: left;
  .link {
    color: #243882;
  }
  button:hover {
    text-decoration: underline;
  }
}
.title-container {
  margin-left: 30px;
  margin-top: 30px;
}
.section-title {
  margin-bottom: 30px;
  color: #243882;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-transform: uppercase;
  display: block;
}
.item-container {
  display: flex;
  margin-bottom: 20px;
  padding: 35px 30px;
  background: #f5f7f8;
}
input {
  font-size: 14px;
}
.right-container {
  width: 100%;
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  text-transform: uppercase;
  input {
    height: 100px;
    width: initial;
    background: $primary-white;
    border: none;
    margin-bottom: 20px;
  }
  .support-docs {
    display: flex;
    align-items: center;
    font-weight: normal;
    text-transform: none;
  }
}
.left-container {
  min-width: 80px;
}
.subtitle {
  margin-bottom: 30px;
  font-weight: normal;
  text-transform: none;
}
.description {
  margin-bottom: 10px;
}
.bottom-container {
  margin: 0px 0 20px 30px;
  display: flex;
  flex-direction: column;
  .radio-container {
    margin-left: 0px;
  }
}
.bottom-info {
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  .info {
    margin-bottom: 15px;
  }
  input {
    width: initial;
    background: $primary-white;
    border: 1px solid #a3a3a3;
    margin-bottom: 20px;
    margin-right: 30px;
    &:read-only {
      cursor: default;
      background: #d1d1d1;
    }
    width: 250px;
  }

  .radio-container {
    margin-right: 20px;
  }
  .dial {
    margin-bottom: 40px;
    display: flex;
    align-items: center;
  }
  .label {
    margin-bottom: 20px;
  }
}
.button-container {
  margin-top: 40px;
  align-items: center;
  justify-content: flex-start;
  button {
    margin-right: 15px;
  }
}
.date {
  width: 160px;
  background: $input-background;
  border: none;
  margin-bottom: 20px;
  margin-right: 20px;
  padding: 13px 0px 13px 20px;
}
.signature-input {
  align-items: flex-end;
  margin: 0px 40px;
  .signature-icon {
    margin-right: 10px;
    svg {
      height: 12px;
      width: 12px;
      path {
        fill: #d1d1d1 !important;
      }
    }
  }
  #signature {
    background: $primary-white;
    border-bottom: solid 1px #d1d1d1;
    width: 350px !important;
    ::v-deep {
      canvas {
        width: 350px !important;
      }
    }
  }
}
.signature-confirmation {
  font-size: 12px;
  margin-left: 60px;
}
.signature-buttons {
  justify-content: flex-end;
  margin-top: 20px;
  .right-btn {
    margin-left: 20px;
  }
}

.appeal-container {
  .appeal-details {
    margin: 40px 30px 20px 30px;
  }
  .form-info {
    margin-bottom: 20px;
    span:not(:first-child) {
      margin: 0 15px;
    }
    span:first-child {
      margin-right: 15px;
    }
  }
}
.form-container {
  margin-top: 45px;
}
.radio {
  background: white !important;
}
.radio-selected {
  background: white !important;
}
.section-label {
  color: $primary-black;
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 20px;
  display: block;
  font-weight: bold;
  line-height: 20px;
}
.signature-section {
  width: 464px;
  border: 1px solid #a3a3a3;
}
.custom-input-buttons {
  padding: 0px 15px 15px;
  align-items: center;
  .separator {
    color: #d1d1d1;
    margin: 0px 7.5px;
  }
  .edit-button {
    font-size: 14px;
    color: #243882;
    cursor: pointer;
  }
  .disabled {
    opacity: 0.7;
    cursor: default;
    pointer-events: none;
  }
}
.cancel-button {
  background-color: $primary-white;
  border: 1px solid $primary;
  color: $primary;
}
.request-details {
  margin-bottom: 45px;
  ul {
    border: 1px solid #d1d1d1;
    margin: 0px;
    padding: 20px;
    width: 704px;
    list-style-type: none;
    li {
      font-size: 14px;
      color: $primary-black;
      margin-bottom: 15px;
      span {
        font-weight: bold;
        font-size: 14px;
      }
    }
    li:last-child {
      margin-bottom: 0px;
    }
  }
}
.input-info {
  margin-top: 20px;
  .custom-input {
    border: 1px solid $border;
    width: 289px;
    height: 47px;
    justify-content: space-between;
    input {
      border: none;
      padding: 0px 0px 0px 15px;
      height: 100%;
      outline: none;
      margin-right: 0px;
    }
    .custom-input-buttons {
      padding-bottom: 0px;
    }
  }
}
.complex-form-container {
  margin: 30px;
  font-size: 14px;
  line-height: 20px;
  span {
    margin-bottom: 20px;
  }
  span:last-child {
    margin-bottom: 0px;
  }
  .title {
    color: #243882;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    text-transform: uppercase;
    margin-bottom: 30px;
  }
  .form-input-info {
    .input-label {
      margin-top: 0px;
    }
  }
}
.helper-text {
  font-size: 14px;
  color: $primary-black;
  &_success {
    color: #008716 !important;
    span {
      color: #008716 !important;
      font-size: 14px !important;
    }
  }
  &_error {
    color: $error !important;
    h4 {
      color: $error !important;
      font-size: 14px !important;
      line-height: 20px !important;
      margin: 15px 0px 0px !important;
      text-transform: none;
    }
  }
  &_notify {
    color: $primary-black;
    opacity: 0.5 !important;
    font-size: 14px !important;
  }
}
.required {
  border: 1px solid red !important;
}
.row-title {
  font-size: 15px;
  line-height: 21px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 35px 0px 15px 0px;
  display: block;
}
.requirements {
  margin: 15px 0px 45px;
  span {
    font-size: 14px;
    line-height: 20px;
    color: $input-readonly-text;
    margin: 10px 0px 0px;
  }
  span:first-child {
    margin: 0px 0px 0px;
  }
}
ul {
  list-style-type: none;
  margin: 0px;
  padding: 0px 30px 0px 0px;
  .input-label {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 25px;
    &.required-level-two {
      margin-top: 55px;
    }
    &.required-dcfc {
      margin-top: 55px;
    }
    &.unidentified-connectors {
      margin-top: 55px;
    }
    &.connector-type {
      margin-top: 10px;
      text-decoration: underline;
      text-align: center;
    }
  }
  .sm {
    width: 200px !important;
  }
  .md {
    width: 239px !important;
  }
  .lg {
    width: 373px !important;
  }
  .xl {
    width: 550px !important;
  }
  .multiselect {
    margin-top: 15px;
  }
  li[disabled] {
    background: $input-readonly;
  }
  span[disabled] {
    pointer-events: none;
    opacity: 0;
  }
  .vendor-note {
    margin-top: 10px;
  }
}
.row-1 {
  ul:last-child {
    padding-right: 0px;
  }
}
.custom-input {
  margin-top: 15px;
  border: 1px solid $border;
  width: 289px;
  height: 47px;
  justify-content: space-between;
  input {
    border: none;
    padding: 0px 15px;
    height: 100%;
  }
  input.disabled {
    pointer-events: none;
    background: #d1d1d1;
    color: $input-readonly-text;
  }
  .custom-input-buttons {
    padding: 0px 15px;
    align-items: center;
    .edit-button {
      font-size: 14px;
      color: #243882;
      cursor: pointer;
    }
    .disabled {
      opacity: 0.7;
      cursor: default;
      pointer-events: none;
    }
  }
}
.row-2 {
  margin: 45px 0px 0px;
}
.row-title-container {
  margin: 0px -30px 0px -30px;
  padding: 16px 30px 17px 30px;
  background-color: $primary;
  justify-content: space-between;
  align-items: center;
}
.row-title-container:hover {
  cursor: pointer;
}
.collapsible-row-title {
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
  text-transform: uppercase;
  color: $primary-white;
  margin: 0px;
}
.input-fields {
  &.non-standard {
    margin-top: 20px;
  }
}
.equipment-type,
.charger-title {
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  color: $primary-white;
  background-color: #008716;
  margin: 0px -30px;
  padding: 10px 30px;
  &.dcfc-chargers {
    margin-top: 25px;
  }
  &.dcfc-connectors {
    margin-top: 45px;
  }
}
.charger-title {
  background-color: #56687b;
  text-transform: none;
  margin-top: 5px;
}
.non-standard-charger {
  margin: 45px 0px;
}
.row-3 {
  margin: 45px 0px 0px;
  .requirements {
    &.connectors {
      margin-bottom: 15px !important;
    }
  }
}
.signature {
  ul {
    .input-label {
      font-size: 15px;
      line-height: 21px;
      font-weight: normal;
      text-transform: none;
      margin-top: 0px !important;
    }
    .input-label-required {
      font-weight: bold;
      text-transform: uppercase;
    }
    .date {
      background: $input-background;
      display: block;
      margin: 15px 0px 0px 15px;
      padding: 0px;
    }
  }
  .note {
    margin-top: 20px;
    display: block;
  }
}
.first-row-element {
  margin-top: 60px;
}
div[disabled] {
  pointer-events: none;
  opacity: 0;
}
.title-box {
  margin-top: 0px;
}
</style>
